import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const Haldi = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [columnCount, setColumnCount] = useState(4);
  const [images, setImages] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;


  // Fetch images from backend
  useEffect(() => {
    axios.get(`${BASE_URL}/api/images/haldi`)  // Laravel API call
      .then(response => {
        console.log("Fetched Images:", response.data);
        setImages(response.data);
      })
      .catch(error => {
        console.error("Error fetching images:", error);
      });
  }, []);
  
  
  const updateColumnCount = useCallback(() => {
    const width = window.innerWidth;
    if (width <= 480) {
      setColumnCount(1);
    } else if (width <= 768) {
      setColumnCount(2);
    } else if (width <= 1024) {
      setColumnCount(3);
    } else {
      setColumnCount(4);
    }
  }, []);

  useEffect(() => {
    updateColumnCount();
    window.addEventListener('resize', updateColumnCount);
    return () => window.removeEventListener('resize', updateColumnCount);
  }, [updateColumnCount]);

  return (
    <>
      <header style={{ width: "100%", height: "auto" }}>
        <div
          style={{
            width: "100%",
            height: "400px",
            backgroundImage: "url('assets/images/Bulk/25.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 1
          }}
        ></div>
      </header>

      <div>
        {/* Masonry Grid */}
        <div style={{ 
          columnCount: columnCount,
          columnGap: "12px",
          padding: "20px",
        }}>
          {images.map((src, index) => (
            <div
              key={index}
              style={{
                display: "inline-block",
                width: "100%",
                marginBottom: "12px",
                breakInside: "avoid",
                cursor: "pointer",
              }}
              onClick={() => setSelectedImage(src)}
            >
              <img
                src={src}
                alt={`Gallery ${index + 1}`}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100vw",
              height: "100vh",
              background: "rgba(0, 0, 0, 0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 99999,
            }}
            onClick={() => setSelectedImage(null)}
          >
            <img
              src={selectedImage}
              alt="Enlarged"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "10px",
              }}
            />
            <button
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                fontSize: "40px",
                background: "none",
                border: "none",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Haldi;
